var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-layout"},[_c('el-menu',{ref:"menu",staticClass:"base-layout__menu",attrs:{"default-active":_vm.defaultActive},on:{"select":_vm.goPath}},[_c('nav-menu',{attrs:{"navMenus":_vm.menuData}})],1),_vm._v(" "),_c('div',{class:['base-layout__content', _vm.hasBackground ? 'base-layout__bg' : '']},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-358d9d4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SliderMenu/index.vue
// module id = null
// module chunks = 